import TableAHSF from "../../../../Components/TableAHSF";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import ContributionOfSecondTeamAdd from "./ContributionOfSecondTeamAdd";
import PopupAHSF from "../../../../Components/PopupAHSF";
import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import { DeleteContributionOfSecondTeam } from "../../../../Redux/Reducers/Submitter/ContributionOfSecondTeam";

const ContributionOfSecondTeam = (props) => {
  const lodingAdd = useSelector(
    (state) =>
      state.ContributionOfSecondTeamReducers.AddContributionOfSecondTeam
  );
  const lodingEdit = useSelector(
    (state) =>
      state.ContributionOfSecondTeamReducers.EditContributionOfSecondTeam
  );
  const lodingDelete = useSelector(
    (state) =>
      state.ContributionOfSecondTeamReducers.DeleteContributionOfSecondTeam
  );

  const AppGuid = useParams();
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const [ContributionOfSecondTeamId, setContributionOfSecondTeamId] =
    useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      // ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
    };
  });
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},

    componentBody: (
      <ContributionOfSecondTeamAdd
        shouldDisableFields={props.shouldDisableFields}
      />
    ),
    maxWidth: "900px",

    maxHeight: "500px",
    title: "مساهمة الفريق الثاني",
  };
  const RequestsColumns = [];
  const RequestAccessor = [
    {
      KeyName: "objectivesAndActivitiesName",
      ShowStatus: true,
      NmaeColumn: "اسم النشاط ",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
  },{
      KeyName: "itemTypeName",
      ShowStatus: true,
      NmaeColumn: "نوع البند",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemName",
      ShowStatus: true,
      NmaeColumn: "اسم البند",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemDescription",
      ShowStatus: true,
      NmaeColumn: "وصف البند",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "numberOfUnits",
      ShowStatus: true,
      NmaeColumn: "عدد الوحدات",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma:true
    },
    {
      KeyName: "unitPrice",
      ShowStatus: true,
      NmaeColumn: "سعر الوحدة",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma:true

    },
    {
      KeyName: "total",
      ShowStatus: true,
      NmaeColumn: "المجموع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma:true

    },
  ];
  const OtherMainBtns = [
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then((res) => {
          if (res.isConfirmed == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            //delete ow from table by id after confirmed
            console.log(e.tag, "malkkskskskjjsd");

            dispatch(
              DeleteContributionOfSecondTeam({
                contributionOfSecondTeamId: parseInt(e.target.value),
              })
            );
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !props.shouldDisableFields,
    },
    {
      Click: async (e) => {
        setContributionOfSecondTeamId(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: !props.shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];
  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [lodingDelete, lodingEdit, lodingAdd]);

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"contributionOfSecondTeamId"}
        valueButtonAction={"contributionOfSecondTeamId"}
        URL={`api/SU_NT_WPB_ContributionOfSecondTeam/GetAllContributionOfSecondTeamByAppGuid`}
        UrlBody={{
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            props.applicationGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!props.shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        total={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        arrayButton={OtherMainBtns}
        arrayButtonLastIndex={false}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />
      <PopupAHSF
        title={"مساهمة الفريق الثاني"}
        componentBody={
          <ContributionOfSecondTeamAdd
            ViewData={true}
            disabledData={false}
            Action={"edit"}
            contributionOfSecondTeamId={ContributionOfSecondTeamId}
            shouldDisableFields={props.shouldDisableFields}
          />
        }
        maxWidth="900px"
        maxHeight="500px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
    </>
  );
};
export default ContributionOfSecondTeam;
